import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Form, Button, Table, Alert } from "react-bootstrap";
import { FaTrash, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./AddWorkAllotment.css";
import api from "../services/api";

const AddInHouse = () => {
  const navigate = useNavigate();
  const [workerNames, setWorkerNames] = useState([]);
  const [products, setProducts] = useState([]);

  // Dummy worker names
  // const workerNames = [
  //   "ABC Industries",
  //   "Srinivasa Industries", 
  //   "XYZ Enterprises",
  //   "Global Industries",
  //   "Local Industries"
  // ];

  // Dummy products
  // const products = [
  //   "Wire Coil",
  //   "Copper Wire",
  //   "PVC Pipe",
  //   "Steel Rod",
  //   "Aluminum Sheet",
  //   "Brass Fitting"
  // ];

  // Fetch suppliers and products from API
  useEffect(() => {
    fetchDropdownData();
  }, []);

  const fetchDropdownData = async () => {
    try {
      // Fetch suppliers
      const workerResponse = await api.post("/job_worker_list.php", {});
      if (workerResponse.data.head.code === 200) {
        setWorkerNames(workerResponse.data.body);
      }

      // Fetch products
      const productsResponse = await api.post("/product_list.php", {});
      if (productsResponse.data.head.code === 200) {
        setProducts(productsResponse.data.body);
      }
    } catch (err) {
      console.error("Error fetching dropdown data:", err);

    }
  };

  // Form state
  const [formData, setFormData] = useState({
    worker_name: "",
    product_from: "",
    product_to: "",
    date: new Date().toISOString().split('T')[0],
    remarks: ""
  });

  // Items state
  const [workItems, setWorkItems] = useState([]);

  // Current item being added
  const [currentItem, setCurrentItem] = useState({
    amount_per_kg: "",
    quantity: ""
  });

  // Errors state
  const [errors, setErrors] = useState({});

  // Refs for focus management
  const workerRef = useRef(null);
  const dateRef = useRef(null);
  const remarkRef = useRef(null);
  const productFromRef = useRef(null);
  const productToRef = useRef(null);
  const qtyRef = useRef(null);
  const amountPerRef = useRef(null);

  // Handle form field changes
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  // Handle current item changes
  const handleCurrentItemChange = (e) => {
    const { name, value } = e.target;
    setCurrentItem(prev => ({ ...prev, [name]: value }));
  };

  // Add item to the list
  const handleAddItem = () => {
    if (!currentItem.quantity || currentItem.quantity <= 0) {
      alert("Please select a product and enter valid quantity");
      return;
    }
    console.log("======formData===========", formData);
    console.log("=====currentItem============", currentItem);
    const newItem = {
      id: Date.now(),
      product_from: formData.product_from,
      amount_per_kg: currentItem.amount_per_kg,
      quantity: parseInt(currentItem.quantity) || 0
    };

    setWorkItems([...workItems, newItem]);

    // Reset current item
    // setCurrentItem({
    //   amount_per_kg: "",
    //   quantity: ""
    // });

    // Focus back on product dropdown
    if (productFromRef.current) {
      productFromRef.current.focus();
    }

    if (productToRef.current) {
      productToRef.current.focus();
    }
  };

  // Handle Enter key navigation
  const handleKeyDown = (e, nextFieldRef, action = null) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (action) {
        action();
      } else if (nextFieldRef && nextFieldRef.current) {
        nextFieldRef.current.focus();
      }
    }
  };

  // Delete item from list
  const handleDeleteItem = (id) => {
    setWorkItems(workItems.filter(item => item.id !== id));
  };

  // Calculate total quantity
  const calculateTotalQuantity = () => {
    return workItems.reduce((total, item) => total + item.quantity, 0);
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};

    if (!formData.worker_name) {
      newErrors.worker_name = "Worker name is required";
    }

    if (!formData.date) {
      newErrors.date = "Date is required";
    }

    if (workItems.length === 0) {
      newErrors.items = "At least one product is required";
    }

    return newErrors;
  };


  // console.log("=== payload =======", payload);

  
// const navigatto = () => {
//     navigate("/workallotment");
//   }
  // Render error message
  const renderError = (field) => {
    return errors[field] ? <div className="text-danger small mt-1">{errors[field]}</div> : null;
  };

  const getProductNameById = (id) => {
    return products.find(p => String(p.id) === String(id))?.name || "";
  };
const formatDateToDMY = (date) => {
  if (!date) return "";
  const [yyyy, mm, dd] = date.split("-");
  return `${dd}-${mm}-${yyyy}`;
};
// Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Call the supplier_add.php API
      const payload = {
        worker_id: formData.worker_name,
        date: formatDateToDMY(formData.date),
        pid: formData.product_from,
        qty: currentItem.quantity,
        note: formData.remarks
      };
      const response = await api.post("/inhouse_add.php", payload);

      if (response.data.head.code === 200) {
        console.log(response.data);
        navigate('/inhouse');
      } else {
        console.log(response.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
    }
    
  };
  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Add In-House usage</h4>
        <Button variant="secondary" onClick={() => navigate("/inhouse")}>
          Back to List
        </Button>
      </div>

      <Form noValidate onSubmit={handleSubmit}>
        <Row className="g-3">
          {/* Worker Selection */}
          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Select Worker *</Form.Label>
              <Form.Select
                ref={workerRef}
                name="worker_name"
                value={formData.worker_name}
                onChange={handleFormChange}
                onKeyDown={(e) => handleKeyDown(e, productFromRef)}
                isInvalid={!!errors.worker_name}
              >
                <option value="">Select Worker</option>
                {workerNames.map((worker, index) => (
                  <option key={index} value={worker.id}>
                    {worker.name}
                  </option>
                ))}
              </Form.Select>
              {renderError("worker_name")}
            </Form.Group>
          </Col>

{/* Date */}
          <Col lg={2} md={2} sm={12}>
            <Form.Group>
              <Form.Label>Date *</Form.Label>
              <Form.Control
                ref={dateRef}
                name="date"
                type="date"
                value={formData.date}
                onChange={handleFormChange}
                onKeyDown={(e) => handleKeyDown(e, remarkRef)}
                // onKeyDown={(e) => handleKeyDown(e, null, handleAddItem)}
                isInvalid={!!errors.date}
              />
              {renderError("date")}
            </Form.Group>
          </Col>

          {/* Product Selection */}
          <Col lg={4} md={4} sm={12}>
            <Form.Group>
              <Form.Label>Select Product *</Form.Label>
              <div className="d-flex gap-2">
                <Form.Select
                  ref={productFromRef}
                  name="product_from"
                  value={formData.product_from}
                  onChange={handleFormChange}
                  onKeyDown={(e) => handleKeyDown(e, productToRef)}
                >
                  <option value="">Select Product</option>
                  {products.map((product, index) => (
                    <option key={index} value={product.id}>
                      {product.name} - {product.product_code}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Form.Group>
          </Col>

          

          {/* Quantity */}
          <Col lg={2} md={2} sm={6}>
            <Form.Group>
              <Form.Label>Quantity *</Form.Label>
              <Form.Control
                ref={qtyRef}
                name="quantity"
                type="number"
                value={currentItem.quantity}
                onChange={handleCurrentItemChange}
                // onKeyDown={(e) => handleKeyDown(e, null, handleAddItem)}
                onKeyDown={(e) => handleKeyDown(e, amountPerRef)}
                placeholder="Enter quantity"
                min="1"
              />
              <small className="text-muted">Press Enter to add item</small>
            </Form.Group>
          </Col>

          

          {/* Add Button */}
          {/* <Col lg={2} md={2} sm={6} className="d-flex align-items-end">
            <Button
              variant="primary"
              onClick={handleAddItem}
              className="w-100 d-flex align-items-center justify-content-center"
              disabled={!currentItem.product || !currentItem.quantity}
            >
              <FaPlus className="me-2" /> Add
            </Button>
          </Col> */}
          

          {/* Remarks */}
          <Col xs={12}>
            <Form.Group>
              <Form.Label>Remarks (Optional)</Form.Label>
              <Form.Control
              ref={remarkRef}
                as="textarea"
                rows={2}
                name="remarks"
                value={formData.remarks}
                onChange={handleFormChange}
                onKeyDown={(e) => handleKeyDown(e, null, handleAddItem)}
                placeholder="Any additional remarks..."
              />
            </Form.Group>
          </Col>
        </Row>

        {/* Items Table */}
        

        {/* Submit Buttons */}
        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button
            type="submit"
            variant="primary"
            // disabled={workItems.length === 0}
            className="px-4"
          >
            Submit Allotment
          </Button>
          <Button
            type="button"
            variant="secondary"
            onClick={() => navigate("/workallotment")}
          
          >
            Cancel
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default AddInHouse;